import { render, staticRenderFns } from "./LectureListAddNew.vue?vue&type=template&id=116693a8&"
import script from "./LectureListAddNew.vue?vue&type=script&lang=js&"
export * from "./LectureListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./LectureListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports